/**
 * driveAssessment
 * 
 * Расчитывает агрессивность вождения на основе кол-ва резких ускорений и торможений за выбранный пробег
 * 
 * @param {Number} acceleration - количество ускорений
 * @param {Number} braking - количество торможений
 * @param {Number} mileage - пробег
 * 
 * @author Igor Abramov <igor.abramov@nami.ru>
 * 
 * @returns {Number / Boolean}
 */
export default function driveAssessment(acceleration = null, braking = null, mileage = null) {

    if(
        acceleration !== null && 
        braking !== null && 
        mileage !== null
    ) {

        acceleration = Number(acceleration)
        braking = Number(braking)
        mileage = Number(mileage)

        if(mileage !== 0) {

            const score_calc = (acceleration + braking) * 100 / mileage
            const score = 100 / (score_calc / 260 + 1)
    
            return Math.round(score)
        }
    }
        
    return false
}